import { Component, NgZone, OnInit, HostListener } from '@angular/core';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { RestService } from '../../services/rest-service';
import { AppSettings } from '../../shared/app-settings';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { AppConstants } from 'src/app/shared/app-constants';
import { environment } from 'src/environments/environment';
declare var google: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements OnInit {
  navigateParam: any;
  toaster: any;
  isDropdownOpen: boolean = false;
  showManagementData: boolean = false;
  managementData: any[] = [];
  loading: boolean = false;

  constructor(private titleService: Title,
    private router: Router,
    private actveRouter: ActivatedRoute,
    public extauthService: AuthenticationService,
    public spinner: SpinnerService,
    private zone: NgZone,
    private toastr: ToastrService,
    private restService: RestService) {
    let obj: any = {
      "setHeadingEnabled": false
    }
    this.extauthService.setHeadingEnabled(obj);
    this.titleService.setTitle("Log In");

  }

  ngOnInit() {
    const params = new URLSearchParams(window.location.search);
    const portalToken = params.get('portalToken');
    if (portalToken) {
      this.loginWithPortalToken(portalToken);
    } else {
      this.initializeGoogleSignIn();
    }

    let title = this.titleService.getTitle();
    this.navigateParam = this.actveRouter.snapshot.queryParams.returnUrl;
  }

  private initializeGoogleSignIn() {
    // Wait for Google script to load
    setTimeout(() => {
      if (typeof google !== 'undefined' && google.accounts) {
        try {
          google.accounts.id.initialize({
            client_id: environment.GOOGLE_CLIENT_ID,
            callback: (resp: any) => {
              let idToken = resp.credential;
              localStorage.setItem('idToken', idToken);
              this.signInWithGoogle(resp);
            },
          });
          
          const googleBtn = document.getElementById('google-btn');
          if (googleBtn) {
            googleBtn.style.display = 'none';
            google.accounts.id.renderButton(googleBtn, {
              type: 'standard',
              shape: 'pill',
              text: 'signin_with',
              size: 'large',
              logo_alignment: 'center',
            });
            setTimeout(() => {
              googleBtn.style.display = 'block';
            }, 1000);
          }
        } catch (error) {
          this.showFallbackLogin();
        }
      } else {
        this.showFallbackLogin();
      }
    }, 2000);
  }

  private showFallbackLogin() {
    const fallbackElement = document.getElementById('fallback-login');
    if (fallbackElement) {
      fallbackElement.style.display = 'block';
    }
  }

  retryGoogleSignIn() {
    const fallbackElement = document.getElementById('fallback-login');
    if (fallbackElement) {
      fallbackElement.style.display = 'none';
    }
    this.initializeGoogleSignIn();
  }

  private async loginWithPortalToken(portalToken: string) {

      this.spinner.activate();
      //const data = await this.extauthService.externalPortalLoginPostRequest(portalToken);
      this.extauthService.externalPortalLoginPostRequest(portalToken)
    .subscribe({
      next: data => {
        localStorage.setItem('ADMIN_JWT', data.token);
        localStorage.setItem('ADMIN_USER', JSON.stringify(data.user));
        this.extauthService.setcurrentUserValue({
          id: data.user.id,
          email: data.user.email,
          firstName: data.user.firstName,
          lastName: data.user.lastName,
          access_token: data.token,
          role: data.user.roles,
          privileges: data.user.privileges
        });
        this.router.navigate(['/cp/logs']);
        this.spinner.deactivate();
      },
      error: err => {
       const status = err?.status || 'Unknown';
       this.spinner.deactivate();
       this.router.navigate(['/login'], { queryParams: { reason: `HTTP ${status}` } });
      }
    });
  }

  isValidMail(mailID: string) {
    var mailPattern = /^[a-zA-Z0-9._-]+@pro-vigil.com$/;
    return mailPattern.test(mailID);
  }

  private decodeToken(token: string) {
    return JSON.parse(atob(token.split('.')[1]));
  }

  signInWithGoogle(response: any): void {
    this.spinner.activate();
    const payload = this.decodeToken(response.credential);
    localStorage.setItem('loggedInUser', JSON.stringify(payload));
    this.extauthService.setimage(payload);
    let model;
    let userData = JSON.parse(localStorage.getItem('loggedInUser'));
    let emailValue = userData.email;
    model = {
      email: emailValue,
      token: localStorage.getItem('idToken'),
    };
    if (this.isValidMail(emailValue)) {
      this.zone.run(() => {
        this.spinner.activate();
      });
      
      try {
        this.extauthService.externalLoginPostRequest(AppSettings.LOGIN, model).subscribe({
          next: (response: any) => {
            if (response) {
              const user = response.user;
              const currUser = {
                id: user.id,
                email: user.email,
                firstName: user.firstName,
                lastName: user.lastName,
                access_token: response.token,
                role: user.roles,
                picture: user.picture,
                privileges: user.privileges
              };
              
              let obj: any = {
                "setHeadingEnabled": true
              };
              this.extauthService.setHeadingEnabled(obj);
              this.extauthService.setcurrentUserValue(currUser);
              
              this.zone.run(() => {
                this.router.navigate(['/cp/logs']);
              });
            } else {
              this.toastr.error("Google login failed. Please try again.");
            }
            this.spinner.deactivate();
          },
          error: (err) => {
            this.spinner.deactivate();
            this.toastr.error("Server error during Google login. Please try again later.");
          }
        });
      } catch (exception: any) {
        this.spinner.deactivate();
        this.toastr.error("Unexpected error. Please try again.");
      }
    }
  }

  signOut(): void {
    this.extauthService.logout();
    this.router.navigate(['/']);
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectUserType(userType: string) {
    this.isDropdownOpen = false;
    if (userType === 'user') {
      // Handle user login logic
      this.showManagementData = false;
      this.managementData = [];
    } else if (userType === 'management') {
      // Handle management data fetching
      this.fetchManagementData();
    }
  }

  fetchManagementData() {
    this.loading = true;
    this.showManagementData = true;
    
    // Try to fetch management data from various possible endpoints
    const possibleEndpoints = [
      'management/users',
      'admin/users',
      'user-management',
      'management',
      'users'
    ];

    let requestCount = 0;
    const maxRequests = possibleEndpoints.length;

    const tryNextEndpoint = () => {
      if (requestCount >= maxRequests) {
        this.loading = false;
        this.toastr.error('Unable to fetch management data. Please try again later.');
        return;
      }

      const endpoint = possibleEndpoints[requestCount];
      requestCount++;

      this.restService.getData(endpoint).subscribe({
        next: (response: any) => {
          this.loading = false;
          if (response && (response.data || response.content || Array.isArray(response))) {
            this.managementData = response.data || response.content || response;
            this.toastr.success('Management data loaded successfully');
          } else {
            tryNextEndpoint();
          }
        },
        error: (error) => {
          tryNextEndpoint();
        }
      });
    };

    tryNextEndpoint();
  }

  closeManagementData() {
    this.showManagementData = false;
    this.managementData = [];
    this.loading = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    const dropdown = document.querySelector('.user-dropdown');
    if (dropdown && !dropdown.contains(target)) {
      this.isDropdownOpen = false;
    }
  }

  ngOnDestroy() {
    const googleBtn = document.getElementById('google-btn');
    if (googleBtn) {
      googleBtn.outerHTML = '';
    }
  }
}
